import { render, staticRenderFns } from "./bank-card-add.vue?vue&type=template&id=35008fd5&scoped=true&"
import script from "./bank-card-add.vue?vue&type=script&lang=js&"
export * from "./bank-card-add.vue?vue&type=script&lang=js&"
import style0 from "./bank-card-add.vue?vue&type=style&index=0&id=35008fd5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35008fd5",
  null
  
)

export default component.exports